import { useQuery } from '@tanstack/react-query';
import { fetchMenu } from '../data/query.js';
import { useMenuAxios } from '../context/axios.js';

const useMenuQuery = () => {
  const {
    instance
  } = useMenuAxios();
  return useQuery({
    queryKey: ["menu"],
    queryFn: () => fetchMenu(instance)
  });
};

export { useMenuQuery };
